/**
 * https://docs.apryse.com/api/web/Core.html#.isFullPDFEnabled
 */
export default () => window.Core.isFullPDFEnabled();
